export default __webpack_public_path__ + "static/media/main-pea.953a5e2e.png";